import { useEffect, useState } from "react";
import Container from "@/components/Container";
import { api } from "@/lib/api";
import { ADMIN } from "@/constants/testIds";
import { toast } from "sonner";

export default function CaseStudiesAdmin() {
  const [items, setItems] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ project_title: "", location: "", short_story: "", design_approach: "", work_completed: "", before_images: "", after_images: "", main_image: "", public: false });
  const [active, setActive] = useState(null);

  const load = () => api.get("/case-studies").then(r => setItems(r.data || []));
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    if (!form.project_title) return toast.error("Title required");
    const payload = {
      ...form,
      before_images: form.before_images.split("\n").filter(Boolean),
      after_images: form.after_images.split("\n").filter(Boolean),
      work_completed: form.work_completed.split("\n").filter(Boolean),
    };
    await api.post("/case-studies", payload);
    toast.success("Case study created"); setShowForm(false);
    setForm({ project_title: "", location: "", short_story: "", design_approach: "", work_completed: "", before_images: "", after_images: "", main_image: "", public: false });
    load();
  };

  const togglePublic = async (cs) => {
    await api.put(`/case-studies/${cs.id}`, { public: !cs.public });
    toast.success(`${!cs.public ? "Published" : "Unpublished"}`);
    load();
  };

  const del = async (id) => { if (!window.confirm("Delete?")) return; await api.delete(`/case-studies/${id}`); load(); };

  return (
    <Container className="py-8 md:py-12">
      <div className="flex items-end justify-between gap-3">
        <div>
          <p className="overline">Deals</p>
          <h1 className="mt-2 text-4xl md:text-5xl font-serif text-ivory">Before & After CMS</h1>
        </div>
        <button onClick={() => setShowForm(s => !s)} className="btn-ruby" data-testid={ADMIN.createCaseStudy}>{showForm ? "Cancel" : "New Case Study"}</button>
      </div>

      {showForm && (
        <form onSubmit={create} className="luxury-card p-6 mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
          <input className="bg-charcoal-800 border border-charcoal-600 px-3 py-2 text-sm md:col-span-2" placeholder="Project title *" value={form.project_title} onChange={e => setForm({...form, project_title:e.target.value})} />
          <input className="bg-charcoal-800 border border-charcoal-600 px-3 py-2 text-sm" placeholder="Location" value={form.location} onChange={e => setForm({...form, location:e.target.value})} />
          <input className="bg-charcoal-800 border border-charcoal-600 px-3 py-2 text-sm" placeholder="Main image URL" value={form.main_image} onChange={e => setForm({...form, main_image:e.target.value})} />
          <textarea rows={3} className="bg-charcoal-800 border border-charcoal-600 px-3 py-2 text-sm md:col-span-2" placeholder="Short story" value={form.short_story} onChange={e => setForm({...form, short_story:e.target.value})} />
          <textarea rows={3} className="bg-charcoal-800 border border-charcoal-600 px-3 py-2 text-sm md:col-span-2" placeholder="Design approach" value={form.design_approach} onChange={e => setForm({...form, design_approach:e.target.value})} />
          <textarea rows={3} className="bg-charcoal-800 border border-charcoal-600 px-3 py-2 text-sm" placeholder="Before image URLs (one per line)" value={form.before_images} onChange={e => setForm({...form, before_images:e.target.value})} />
          <textarea rows={3} className="bg-charcoal-800 border border-charcoal-600 px-3 py-2 text-sm" placeholder="After image URLs (one per line)" value={form.after_images} onChange={e => setForm({...form, after_images:e.target.value})} />
          <textarea rows={3} className="bg-charcoal-800 border border-charcoal-600 px-3 py-2 text-sm md:col-span-2" placeholder="Work completed (one per line)" value={form.work_completed} onChange={e => setForm({...form, work_completed:e.target.value})} />
          <label className="flex items-center gap-2 text-sm md:col-span-2"><input type="checkbox" checked={form.public} onChange={e => setForm({...form, public: e.target.checked})} className="accent-ruby" /> Publish publicly</label>
          <button className="btn-ruby md:col-span-2 justify-center">Create Case Study</button>
        </form>
      )}

      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.length === 0 && <p className="luxury-card p-8 text-center text-ivory/40 text-sm md:col-span-3">No case studies yet.</p>}
        {items.map(cs => (
          <div key={cs.id} className="luxury-card p-5" data-testid={`case-study-${cs.id}`}>
            {cs.main_image && <img src={cs.main_image} alt="" className="w-full aspect-[4/3] object-cover mb-3" />}
            <p className="overline">{cs.location}</p>
            <p className="text-ivory mt-2 font-serif text-xl">{cs.project_title}</p>
            <p className="text-xs mt-2"><span className={cs.public ? "text-gold" : "text-ivory/40"}>{cs.public ? "● Public" : "○ Draft"}</span></p>
            <div className="flex gap-2 mt-4">
              <button onClick={() => togglePublic(cs)} className="btn-outline !py-1 !px-3 !text-[0.7rem]">{cs.public ? "Unpublish" : "Publish"}</button>
              <button onClick={() => del(cs.id)} className="btn-outline !py-1 !px-3 !text-[0.7rem]">Delete</button>
            </div>
          </div>
        ))}
      </div>
    </Container>
  );
}
